import React, { useEffect } from 'react';
import { useLoaderData } from '@tanstack/react-router';

import { APIregisterTimelineView } from '../api/Timeline';

import TimelineHeader from '../components/Timeline/Header';
import TimelineMemoryCard from '../components/Timeline/MemoryCard';
import TimelineButtons from '../components/Timeline/Buttons';
import TimelineStats from '../components/Timeline/Stats';
import MemoryTimeline from '../components/Memory/Timeline';
import TimelineReactions from '../components/Timeline/Reactions';
import TimelineContributors from '../components/Timeline/Contributors';
import Notices from '../components/Notices';

import type { Memory } from '../types/memory';

const TimelineView: React.FC = () => {
  const {
    timeline,
    mode,
  } = useLoaderData({ strict: false });

  useEffect(() => {
    if (mode === 'public') {
      APIregisterTimelineView(timeline.id);
    }
  }, [timeline.id, mode]);

  return (
    <div className="container timeline-view-container">
      <div className="timeline-header wa-stack wa-gap-0 inner">
        <Notices />
        <TimelineHeader
          timeline={timeline}
          mode={mode}
        />
      </div>
      <div className="wa-flank wa-flank:end wa-gap-0 wa-align-items-start" style={{ '--flank-size': '400px' } as React.CSSProperties}>
        <div className={`timeline-view wa-stack${timeline.contributor ? ' timeline-view-contributor' : ''}`}>
          {timeline.contributor && (
            <div className="timeline-view-contributor-notice">
              <wa-callout>
                <i className="fa-regular fa-user-plus" slot="icon"></i>
                <strong>You're a contributor on this Timeline</strong><br />
                You can add your own memories. The owner will be notified when you contribute.
              </wa-callout>
            </div>
          )}
          <div className="timeline-view-line" />
          <div className="timeline-view-inner wa-stack inner">
            {timeline.memories.map((memory: Memory) => (
              <TimelineMemoryCard
                key={memory.id}
                memory={memory}
                timeline={timeline}
                mode={mode}
              />
            ))}
          </div>
        </div>
        <div className="timeline-view-sidebar inner">
          {mode === 'private' ? (
            <>
              <TimelineButtons timeline={timeline} page="view" />
              <TimelineStats timeline={timeline} />
              <TimelineContributors timeline={timeline} />
            </>
          ) : (
            <>
              <MemoryTimeline timeline={timeline} />
              {timeline.allow_reactions && (
                <TimelineReactions timeline={timeline} />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default TimelineView;
